import { ResultTitleViewModel } from 'models';
import { FullPropertySearch } from '__generated__/api';

export const mapResultTitleViewModel = (query: FullPropertySearch.Query): ResultTitleViewModel => {
  const resultTitleModel = query.propertySearch.summary.resultsTitleModel;

  return {
    header: resultTitleModel.header,
    subHeader: resultTitleModel.subHeader,
    separator: '•',
    link: resultTitleModel.link,
    icon: resultTitleModel.icon && resultTitleModel.icon.id
  };
};
